import { CollaboratorsApiRemoteService } from '../../Services/api/collaborators/collaborators-service'
import {  ICollaboratorEntity, ICreateCollaboratorPayload } from '../../Services/api/collaborators/collaborators.interface'
import { IFormUsecase } from '../../Shared/Protocol/protocol-form-usecase'
import { Result } from '../../Shared/Protocol/protocol-result'


export class ChangeCollaboratorPasswordUseCase
implements IFormUsecase<string, void> {
  constructor (private readonly CollaboratorsApi: CollaboratorsApiRemoteService) {}
    

  public async handle (
    password: string
  ): Promise<Result<void>> {
    // eslint-disable-next-line no-useless-catch
    try {

      const response = await this.CollaboratorsApi.changePassword(password)

      if (response.isFailure) {
        return response
      }
    
      return Result.ok()
    } catch (error: any) {
      return Result.fail(error)
    }
  }

 
}
